// extracted by mini-css-extract-plugin
export var bulk = "styles-module--bulk--5e5d2";
export var center = "styles-module--center--c84c4";
export var loading = "styles-module--loading--e0fe8";